import { StageInfo } from 'erm-sdk';

export const environment = {
  production: true,
  stage: StageInfo.DEV,
  authority: 'https://signin.dev-connect.aveva.com',
  clientId: 'Y0q7tc7rsW3XmAHXBfJfFNgLVpS7Bz9K',
  singleSignOutUrl: 'https://profile.capdev-connect.aveva.com/singlesignout',
  sessionExpiredUrl: 'https://profile.capdev-connect.aveva.com/sessionexpired',
  userProfileManagementUrl: 'https://profile.capdev-connect.aveva.com/myprofile/details',
  connect: 'https://capdev-connect.aveva.com',
  apis: {
    am: 'https://api.capdev-connect.aveva.com/am',
    registry: 'https://api.capdev-connect.aveva.com/registry',
    uam: 'https://services.capdev-connect.aveva.com/uam/v2',
    scm: 'https://api.capdev-connect.aveva.com/scm',
    logging: 'https://api.capdev-connect.aveva.com/logging',
    assets: 'https://api.capdev-connect.aveva.com/assets',
    ermCapability: 'https://api.dev-erm.capdev-connect.aveva.com/erm'
  }
};